import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';
import { minorTestShellStyles } from '../shell.styles';

const { colors, fonts, fontSize, spacing, breakpoints, sizes } = redesignTheme;

export const useMinorTestPresentationStyles = makeStyles(() => ({
  ...minorTestShellStyles,
  header: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    minHeight: 56,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    padding: `12px ${spacing.md}px`,
    backgroundColor: colors.white,
    borderBottom: `1px solid ${colors.surfaceBorder}`,
    boxSizing: 'border-box',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      padding: `12px ${spacing.sm}px`,
      gap: spacing.xs,
    },
  },
  main: {
    maxWidth: 1280,
    margin: '0 auto',
    padding: '24px 56px 96px',
    boxSizing: 'border-box',
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      padding: `${spacing.md}px ${spacing.sm}px ${spacing.xl}px`,
    },
  },
  backButtonWrap: {
    marginBottom: spacing.md,
  },
  layout: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    gap: 22,
    alignItems: 'start',
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      gridTemplateColumns: '1fr',
      gap: spacing.md,
    },
  },
  imageWrap: {
    minHeight: 496,
    height: 'calc(100vh - 208px)',
    maxHeight: 696,
    borderRadius: 4,
    overflow: 'hidden',
    backgroundColor: colors.progressTrackMuted,
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      minHeight: 260,
      height: 'auto',
      aspectRatio: '16 / 10',
    },
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      aspectRatio: '4 / 3',
    },
  },
  image: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  card: {
    minHeight: 496,
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
    padding: 40,
    borderRadius: 4,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    backdropFilter: 'blur(10px)',
    boxSizing: 'border-box',
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      minHeight: 0,
      padding: spacing.md,
    },
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      gap: spacing.md,
      padding: spacing.sm,
    },
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  title: {
    margin: 0,
    color: colors.primary,
    fontFamily: fonts.gothicBold,
    fontSize: fontSize.xl,
    lineHeight: 1.25,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.lg,
    },
  },
  duration: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
    color: '#151528',
    fontSize: fontSize.md,
    lineHeight: '20px',
  },
  description: {
    color: colors.textBody,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    lineHeight: 1.4,
    '& p, & h3': {
      margin: 0,
    },
    '& *': {
      fontFamily: `${fonts.opensans} !important`,
      background: 'transparent !important',
    },
    '& a': {
      color: `${colors.primaryDark} !important`,
    },
  },
  primaryButton: {
    borderColor: colors.primaryDark,
    backgroundColor: colors.primaryDark,
    color: colors.white,
    '&:hover': {
      backgroundColor: colors.primaryDark,
      opacity: 0.92,
    },
  },
  startButton: {
    width: '100%',
  },
  loadingCenter: {
    minHeight: '70vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
